module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-east-west-coast/key-2-2015.svg?v=ab10d7ba";